// @ts-nocheck
import React from 'react'
import getContentTypeConfig from './config'
import dynamic from 'next/dynamic'

import 'react-perfect-scrollbar/dist/css/styles.css'
const Parallax = dynamic(() => import('@corratech/pylot-parallax'))
const PerfectScrollbar = dynamic(() => import('react-perfect-scrollbar'))

/**
 * Render a content type
 *
 * @param Component
 * @param data
 * @returns {*}
 */
const renderContentType = (
    Component,
    data,
    AddToWishlist,
    AddToWishlistLabel,
    globalOptions,
    isLazyLoad,
    ProductTile,
    productQuery,
    extendedContentTypeConfig,
    imageNavCallback,
    isShopTheLookLayout
) => {
    const cssClasses = data.cssClasses
    const inheritedShopLook =
        Boolean(isShopTheLookLayout) ||
        (Array.isArray(cssClasses) &&
            cssClasses.some((cssClass) =>
                String(cssClass).includes('shop-the-look')
            ))

    return (
        <Component
            {...data}
            AddToWishlist={AddToWishlist}
            AddToWishlistLabel={AddToWishlistLabel}
            globalOptions={globalOptions}
            isLazyLoad={isLazyLoad}
            ProductTile={ProductTile}
            productQuery={productQuery}
            imageNavCallback={imageNavCallback}
            isShopTheLookLayout={inheritedShopLook}
        >
            {(data.children || []).map((childTreeItem, i) => (
                <ContentTypeFactory
                    key={i}
                    data={childTreeItem}
                    AddToWishlist={AddToWishlist}
                    AddToWishlistLabel={AddToWishlistLabel}
                    globalOptions={globalOptions}
                    isLazyLoad={isLazyLoad}
                    ProductTile={ProductTile}
                    productQuery={productQuery}
                    extendedContentTypeConfig={extendedContentTypeConfig}
                    imageNavCallback={imageNavCallback}
                    isShopTheLookLayout={inheritedShopLook}
                />
            ))}
        </Component>
    )
}

/**
 * Create an instance of a content type component based on configuration
 *
 * @param data
 * @returns {*}
 * @constructor
 */
const ContentTypeFactory = ({
    data,
    AddToWishlist,
    AddToWishlistLabel,
    isLazyLoad,
    ProductTile,
    productQuery,
    extendedContentTypeConfig,
    imageNavCallback,
    isShopTheLookLayout
}) => {
    const { isHidden, ...props } = data

    const globalOptions = {}

    if (isHidden) {
        return null
    }

    const contentTypeConfig = getContentTypeConfig(
        props.contentType,
        extendedContentTypeConfig
    )
    if (contentTypeConfig && contentTypeConfig.component) {
        const renderComponent = renderContentType(
            contentTypeConfig.component,
            props,
            AddToWishlist,
            AddToWishlistLabel,
            globalOptions,
            isLazyLoad,
            ProductTile,
            productQuery,
            extendedContentTypeConfig,
            imageNavCallback,
            isShopTheLookLayout
        )

        if (props.cssClasses && props.cssClasses.includes('corra-parallax')) {
            return (
                <Parallax classes={props.cssClasses}>
                    {renderComponent}
                </Parallax>
            )
        } else if (
            props.cssClasses &&
            props.cssClasses.includes('corra-scrollbar')
        ) {
            return (
                <PerfectScrollbar>
                    <div className="scrollbar-wrap">{renderComponent}</div>
                </PerfectScrollbar>
            )
        } else {
            return renderComponent
        }
    }

    return null
}

export default ContentTypeFactory
